import React from 'react'
import { QuestionUtils } from '../../../utils/siteUtils'

import Question from './Question'

export default ({ getQuestionResponse, saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment, question, locked, shouldShowCheck }) => {
  const { questionLabel, questionId, questionChoices } = QuestionUtils.getQuestionLabelAndChoices(question)
  const selectedIndex = getQuestionResponse(questionId).v

  return (
    <Question
      question={{ ...question, selectChoices: [] }}
      title={questionLabel}
      subtitle={question.labelExtended}
      selectedIndex={selectedIndex}
      questionChoices={question.questionType === 'Boolean' ? ['Yes', 'No'] : questionChoices}
      questionId={questionId}
      {...{ saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment }}
      errorMessage={question.errorMessage}
      fullWidth={true}
      locked={locked}
      shouldShowCheck={shouldShowCheck}
    />
  )
}
